import { render, staticRenderFns } from "./OfficeVersion.vue?vue&type=template&id=91f8af56"
import script from "./OfficeVersion.vue?vue&type=script&lang=js"
export * from "./OfficeVersion.vue?vue&type=script&lang=js"
import style0 from "./OfficeVersion.vue?vue&type=style&index=0&id=91f8af56&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports